import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module')
      .then(m => m.LoginPageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    loadChildren: () => import('./welcome/welcome.module')
      .then(m => m.WelcomePageModule)
  },
  {
    path: 'userregistration',
    loadChildren: () => import('./userregistration/userregistration.module')
      .then(m => m.UserregistrationPageModule)
  },
  {
    path: 'changepassword/:id',
    loadChildren: () => import('./changepassword/changepassword.module')
      .then(m => m.ChangepasswordPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module')
      .then(m => m.HomePageModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./payment/payment.module')
      .then(m => m.PaymentPageModule)
  },
  {
    path: 'logout',
    loadChildren: () => import('./logout/logout.module')
      .then(m => m.LogoutPageModule)
  },
  {
    path: 'confirmpayment',
    loadChildren: () => import('./confirmpayment/confirmpayment.module')
      .then(m => m.ConfirmpaymentPageModule)
  },
  {
    path: 'paymentsummary',
    loadChildren: () => import('./paymentsummary/paymentsummary.module')
      .then(m => m.PaymentsummaryPageModule)
  },
  {
    path: 'contactus',
    loadChildren: () => import('./contactus/contactus.module')
      .then(m => m.ContactusPageModule)
  },
  {
    path: 'detsummary',
    loadChildren: () => import('./detsummary/detsummary.module')
      .then(m => m.DetsummaryPageModule)
  }, {
    path: 'myprofile',
    loadChildren: () => import('./myprofile/myprofile.module').then(m => m.MyprofilePageModule)
  },
  {
    path: 'modeldropdown',
    loadChildren: () => import('./modeldropdown/modeldropdown.module').then( m => m.ModeldropdownPageModule)
  },
  {
    path: 'studentattendance',
    loadChildren: () => import('./studentattendance/studentattendance.module').then( m => m.StudentattendancePageModule)
  },
  {
    path: 'assignment',
    loadChildren: () => import('./assignment/assignment.module').then(m => m.AssignmentPageModule)
  },
  {
    path: 'addassignment',
    loadChildren: () => import('./addassignment/addassignment.module').then(m => m.AddassignmentPageModule)
  },
  {
    path: 'myclass',
    loadChildren: () => import('./myclass/myclass.module').then( m => m.MyclassPageModule)
  },
  {
    path: 'myclass-details',
    loadChildren: () => import('./myclass-details/myclass-details.module').then( m => m.MyclassDetailsPageModule)
  },
  {
    path: 'file-upload',
    loadChildren: () => import('./file-upload/file-upload.module').then( m => m.FileUploadPageModule)
  }
] 




@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
